<table mat-table [dataSource]="dataSource" class="mat-elevation-z8" multiTemplateDataRows>

    <ng-container matColumnDef="payAmnt">
        <th mat-header-cell *matHeaderCellDef class="rtalign font10">{{engLang ? 'Payed': 'Pagado'}}
        </th>
        <td mat-cell *matCellDef="let pay" class="rtalign font10">
            {{makeNum(pay.payAmnt) | currency:'USD':'':'0.2-2'}} </td>
    </ng-container>

    <ng-container matColumnDef="payPS">
        <th mat-header-cell *matHeaderCellDef class="text-center font10"> {{engLang ? 'Ps': 'Fp'}} </th>
        <td mat-cell *matCellDef="let pay" class="text-center font10">
            {{pay.payPS}} </td>
    </ng-container>

    <ng-container matColumnDef="payMode">
        <th mat-header-cell *matHeaderCellDef class="font10"> {{engLang ? 'Mode': 'Modo'}} </th>
        <td mat-cell *matCellDef="let pay" class="font10">
            {{pay.payMode}} </td>
    </ng-container>

    <ng-container matColumnDef="payCkNo">
        <th mat-header-cell *matHeaderCellDef class="font10">Check No.</th>
        <td mat-cell *matCellDef="let pay" class="font10">
            {{pay.payCkNo}} </td>
    </ng-container>

    <ng-container matColumnDef="payMemo">
        <th mat-header-cell *matHeaderCellDef class="font9">Memo</th>
        <td mat-cell *matCellDef="let pay" class="font10">
            {{pay.payMemo}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" class="pay-header-row"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="pay-row">
    </tr>
    <!-- <tr mat-row *matRowDef="let row; columns: ['expandDets'];" [class.expandedRw]="isExpanded(row)"></tr> -->
    <!-- <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr> -->

</table>